import React from 'react';
import InputList from '../InputList';

var GeoSearch = function GeoSearch(props) {
  var url = 'https://atlas.microsoft.com/search/address/json';

  var getParams = function getParams(text) {
    return {
      'api-version': '1.0',
      'subscription-key': props.subscriptionKey,
      query: text
    };
  };

  var getValue = function getValue(obj) {
    return "".concat(obj.position.lat, ",").concat(obj.position.lon);
  };

  var getLabel = function getLabel(obj) {
    return obj.address.freeformAddress;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputList, {
    url: url,
    getValue: getValue,
    getLabel: getLabel,
    getParams: getParams,
    onSelect: props.onSelect,
    initValue: props.initValue,
    defaultValue: props.defaultValue,
    placeholder: props.placeholder
  }));
};

export default GeoSearch;